const CONSTANTS = {
    INPUT_WIDTH: 343,
    INPUT_HEIGHT: 40,
    INPUT_BORDER: '2px solid var(--border, #D0D3D8)',
};

const MESSAGES = {
    MESSAGE_REQUIRED: 'Please input your username!',
};

const PLACEHOLDERS = {
    PLEASE_ENTER: '入力してください',
};

export { CONSTANTS, MESSAGES, PLACEHOLDERS };
